
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    get() {
        return axios.get(`${API_URL}/settings`, { headers: authHeader() });
    },
    updateData(data) {
        return axios.post(`${API_URL}/settings`, data, { headers: authHeader() });
    },
   
};